/* ============================================================
   Decompte croissant pour les chiffres du bloc "manifesto"
   (ai_gen_block_0a511c1) - 2026-09
   ------------------------------------------------------------
   POURQUOI CE FICHIER EXISTE

   L'app anime elle-meme ses chiffres, mais uniquement quand
   data-value est un ENTIER NU. Valeurs reellement presentes :
       data-value="2022"     -> anime par l'app
       data-value="+ 330"    -> ignore (le "+ " casse le parseur)
       data-value="+ 4500"   -> ignore
   Resultat : un seul chiffre sur trois s'animait.

   Ce script ne prend en charge QUE les chiffres que l'app
   laisse statiques. Test : /^\d+$/ sur data-value.
     - entier nu -> on ne touche a rien, l'app s'en charge
     - sinon     -> on anime nous-memes
   Aucun risque de double animation.

   MISE EN FORME : le prefixe, le suffixe ET l'espacement
   d'origine sont preserves.
   /!\ On n'applique un separateur de milliers que si la valeur
   d'origine en contient un. Sinon "+ 4500" defilait en
   "+ 2 217" puis retombait sur "+ 4500" sans espace : un
   micro-saut visible sur la derniere image.

   /!\ Le script est charge par snippets/marmote-base.liquid,
   appele une fois par section Marmote (5 fois sur l'accueil).
   Des balises <script src> identiques s'EXECUTENT autant de
   fois qu'elles apparaissent - seul le telechargement est
   dedoublonne. D'ou le drapeau global. Ne pas le retirer.

   ACCESSIBILITE : si le visiteur a demande de reduire les
   animations, la valeur finale est ecrite directement.
   ============================================================ */
(function () {
  if (window.__mmAppblockCount) return;
  window.__mmAppblockCount = true;

  var SEL = '[class*="aigenblock0a511c1"] [class$="__number"]';
  var REDUIT = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function demarrer() {
    var els = document.querySelectorAll(SEL);
    if (!els.length) return;

    var cibles = [];
    Array.prototype.forEach.call(els, function (el) {
      var brut = (el.getAttribute('data-value') || el.textContent || '').trim();
      if (!brut) return;
      if (/^\d+$/.test(brut)) return;              // l'app s'en occupe

      var m = brut.match(/^(\D*?)([\d\s .,]+)(\D*)$/);
      if (!m) return;

      var avant = m[1], chiffres = m[2], apres = m[3];
      // l'espace qui suit le prefixe appartient au prefixe, pas au nombre
      var esp = chiffres.match(/^[\s ]+/);
      if (esp) { avant += esp[0]; chiffres = chiffres.slice(esp[0].length); }

      var n = parseInt(chiffres.replace(/[^\d]/g, ''), 10);
      if (!isFinite(n) || n <= 0) return;

      el.style.fontVariantNumeric = 'tabular-nums';  // evite que la largeur saute
      cibles.push({
        el: el, avant: avant, n: n, apres: apres, fin: brut,
        // separateur de milliers seulement si la source en a un
        sep: /[\s .,]/.test(chiffres.trim())
      });
    });
    if (!cibles.length) return;

    function rendu(c, v) {
      return c.avant + (c.sep ? v.toLocaleString('fr-FR') : String(v)) + c.apres;
    }

    if (REDUIT) {
      cibles.forEach(function (c) { c.el.textContent = c.fin; });
      return;
    }

    cibles.forEach(function (c) { c.el.textContent = rendu(c, 0); });

    var lance = false;
    function animer() {
      if (lance) return;
      lance = true;
      var duree = 1400, t0 = null;
      function pas(t) {
        if (t0 === null) t0 = t;
        var p = Math.min((t - t0) / duree, 1);
        var e = 1 - Math.pow(1 - p, 3);            // ralentit en fin de course
        cibles.forEach(function (c) { c.el.textContent = rendu(c, Math.round(c.n * e)); });
        if (p < 1) requestAnimationFrame(pas);
        else cibles.forEach(function (c) { c.el.textContent = c.fin; });
      }
      requestAnimationFrame(pas);
    }

    var ancre = cibles[0].el.closest('[class$="__stats"]') || cibles[0].el;
    if (!('IntersectionObserver' in window)) { animer(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { animer(); io.disconnect(); }
      });
    }, { threshold: 0.35 });
    io.observe(ancre);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
